import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/tadada-logo.png";

// Renders the official "tadada" logo (supplied artwork, transparent background).
// `size` is the rendered height in px. `monochrome` inverts it to white for dark
// footers. Component name kept as AvianLogo to avoid churning imports.
export function AvianLogo({ className = "", size = 28, monochrome = false }) {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="avian-logo-link">
      <img
        src={logo}
        alt="tadada"
        style={{ height: size, width: "auto", filter: monochrome ? "brightness(0) invert(1)" : "none" }}
        className="block select-none"
        draggable={false}
      />
    </Link>
  );
}
